module.exports = __webpack_public_path__ + "static/media/emptycard.d18de9b7.png";